import { GridCellProps, GridColumn } from "@progress/kendo-react-grid";
import React from 'react';
import { Component } from "puzzle";
import { SESSIONS_DATA } from "./Types";
import { getTableTdAccessibilityProps } from "../../util/Util";
import KendoGridAbstract from "../../util/KendoGridAbstract/KendoGridAbstract";

export type PROPS = {
  sessionsData: {
    userSessions: SESSIONS_DATA
  }
};

export type STATE = {}

class ActiveSessions extends Component<PROPS, STATE> {
  static defaultProps = {
    sessionsData: {}
  };
  public state: STATE = {};

  /**
   * Location column renderer.
   */
  locationColumnRender = (cellProps: GridCellProps) => {
    const { dataItem, field } = cellProps;
    let location = null;
    if (field) {
      location = dataItem[field];
    }
    const tdProps = getTableTdAccessibilityProps(cellProps);

    return (
      dataItem.currentUserSession ? (
        <td
          {...tdProps}
        >
          {location} <span className={'tp-font-italic'}>({this.translate('activityCurrent')})</span>
        </td>
      ) : (
        <td
          {...tdProps}
        >
          <span>{location}</span>
        </td>
      )
    );
  };

  /**
   * Login time column renderer.
   * Format timestamp to string based on format from localisation.
   */
  loginTimeColumnRender = (cellProps: GridCellProps) => {
    const { dataItem, field } = cellProps;
    let loginTime = null;
    if (field) {
      loginTime = this.translateByNamespace('date.dateWithTime', {
        date: new Date(dataItem[field])
      });
    }
    const tdProps = getTableTdAccessibilityProps(cellProps);
    return <td {...tdProps}>{loginTime}</td>;
  };

  getColumnConfiguration() {
    return [{
      field: 'userAgent',
      key: 'userAgent',
      title: this.translate('accessInformation')
    }, {
      field: 'ipAddress',
      key: 'ipAddress',
      title: this.translate('locations'),
      cell: this.locationColumnRender,
      width: 250
    }, {
      field: 'loginTime',
      key: 'loginTime',
      title: this.translate('loginDate'),
      cell: this.loginTimeColumnRender,
      width: 200
    }];
  }

  renderBody() {
    const { sessionsData } = this.props;
    const columns = this.getColumnConfiguration();
    return (
      <KendoGridAbstract
        captionText={this.translate('SRL-activeSessionsTableCaption')}
        className={'tp-active-session-grid tp-no-border'}
        data={sessionsData.userSessions}
      >
        {columns.map(column => <GridColumn {...column} />)}
      </KendoGridAbstract>
    );
  }
}

export default ActiveSessions;
